import Grid from '@mui/material/Grid2';
import makeStyles from '@mui/styles/makeStyles';
import React, { useContext, useState } from 'react';
import Modal from '../../../../components/Modals';
import MonetaryLineGraphContext from './MonetaryLineGraphContext';
import MonetaryLineGraph from './monetaryLineGraph';
import ProductionLineGraphContext from './ProductionLineGraphContext';
import ProductionLineGraph from './productionLineGraph';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  graph: {
    display: 'flex',
    flex: '1 1 auto',
    minHeight: 0,
  },
  modal: {
    backgroundColor: 'white',
    height: '85%',
    width: '90%',
    maxHeight: '600px',
    maxWidth: '1400px',
  },
  half: {
    height: '50%',
  },
}));

const LineGraphs = ({ portfolios, consolidateAssetsProps }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const {
    range: prodRange,
    modalRange: prodModalRange,
    setModalRange: prodSetModalRange,
  } = useContext(ProductionLineGraphContext);
  const {
    range: cashRange,
    modalRange: cashModalRange,
    setModalRange: cashSetModalRange,
  } = useContext(MonetaryLineGraphContext);

  const closeFullscreen = () => {
    setOpen(false);
    prodSetModalRange({ x: [], y: [] });
    cashSetModalRange({ x: [], y: [] });
  };

  return (
    <>
      {/** biome-ignore lint/correctness/useUniqueElementIds: Needed for the tutorial feature */}
      <div id='portfolio-analysis-production-line-graphs'>
        <ProductionLineGraph
          open={open}
          setOpen={() => setOpen(true)}
          range={prodRange}
          appBarId='portfolio-analysis-graph-app-bar'
        />
      </div>
      {/** biome-ignore lint/correctness/useUniqueElementIds: Needed for the tutorial feature */}
      <div id='portfolio-analysis-cashflow-line-graphs'>
        <MonetaryLineGraph
          open={open}
          setOpen={() => setOpen(true)}
          range={cashRange}
          consolidateAssetsProps={consolidateAssetsProps}
          portfolios={portfolios}
        />
      </div>
      <Modal
        handleClose={closeFullscreen}
        open={open}
        title='Chart Expansion'
        titleAlignedWithClose={true}
        styles={classes}
        disablePortal
      >
        <Grid container className={classes.root}>
          <Grid container className={classes.graph} direction='column'>
            <div className={classes.half}>
              <ProductionLineGraph
                open={open}
                setClose={closeFullscreen}
                showLegend
                range={prodModalRange}
              />
            </div>
            <div className={classes.half}>
              <MonetaryLineGraph
                open={open}
                setClose={closeFullscreen}
                showLegend
                range={cashModalRange}
                consolidateAssetsProps={consolidateAssetsProps}
                portfolios={portfolios}
              />
            </div>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};

export default LineGraphs;
